"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationIdLookupToJSON = exports.ApplicationIdLookupFromJSONTyped = exports.ApplicationIdLookupFromJSON = void 0;
function ApplicationIdLookupFromJSON(json) {
    return ApplicationIdLookupFromJSONTyped(json, false);
}
exports.ApplicationIdLookupFromJSON = ApplicationIdLookupFromJSON;
function ApplicationIdLookupFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'applicationId': json['applicationId'],
        'dob': (new Date(json['dob'])),
    };
}
exports.ApplicationIdLookupFromJSONTyped = ApplicationIdLookupFromJSONTyped;
function ApplicationIdLookupToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'applicationId': value.applicationId,
        'dob': (value.dob.toISOString().substr(0, 10)),
    };
}
exports.ApplicationIdLookupToJSON = ApplicationIdLookupToJSON;
//# sourceMappingURL=ApplicationIdLookup.js.map